import type { MouseEvent } from 'react'
import {
  PulseFieldContainer,
  PulseFieldLabel,
} from '@/shared/components/SDComponentsNewDesign/SDFieldLabel/styled-components'
import ChoiceOption from './ChoiceOption/ChoiceOption'
import { OptionList } from '../styled-components'

interface ChoiceGroupProps {
  label: string
  options: Array<{ label: string; selected: boolean; onClick: (event: MouseEvent) => void }>
}

const ChoiceGroup = ({ label, options }: ChoiceGroupProps) => (
  <PulseFieldContainer role='group' aria-label={label}>
    <PulseFieldLabel aria-hidden='true'>{label}</PulseFieldLabel>
    <OptionList>
      {options.map(option => (
        <ChoiceOption key={option.label} {...option} />
      ))}
    </OptionList>
  </PulseFieldContainer>
)

export default ChoiceGroup
